import { _getCookieValue } from "./commonFunctions_v2";

export const RELOAD_COOKIE = "error_boundary_reload";
export const RELOAD_COOLDOWN_MS = 20 * 1000;
const RELOAD_QUERY_PARAM = "_staleReload";

/** Stale tab after deploy — lazy route chunk or CSS chunk 404 / network fail. */
export const STALE_ASSET_CHUNK_ERROR = /Loading chunk [\d]+ failed|Loading CSS chunk [\d]+ failed|ChunkLoadError|Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|missing:\s*https?:\/\/[^\s]+\/(static\/js|static\/css)/i;

export function isStaleAssetChunkError(error) {
    const msg = String(error?.message || error?.name || error || "").trim();
    return msg.length > 0 && STALE_ASSET_CHUNK_ERROR.test(msg);
}

function setReloadCooldownCookie(timestamp) {
    const maxAgeSec = Math.ceil(RELOAD_COOLDOWN_MS / 1000) + 5;
    document.cookie = `${RELOAD_COOKIE}=${timestamp}; path=/; max-age=${maxAgeSec}; SameSite=Lax`;
}

export function shouldSkipStaleAssetReload(now = Date.now()) {
    const lastReloadAt = parseInt(_getCookieValue(RELOAD_COOKIE) || "0", 10);
    if (!Number.isFinite(lastReloadAt) || lastReloadAt <= 0) return false;
    return now - lastReloadAt < RELOAD_COOLDOWN_MS;
}

/** Cache-busting navigation so index.html / main bundle are re-fetched after deploy. */
function navigateForStaleAppAssets(now) {
    if (!navigator?.onLine) {
        window.location.href = "/";
        return;
    }

    const url = new URL(window.location.href);
    url.searchParams.set(RELOAD_QUERY_PARAM, String(now));
    window.location.replace(url.toString());
}

/** User clicked Reload — always fetch fresh shell, ignore cooldown. */
export function forceReloadApp() {
    const now = Date.now();
    setReloadCooldownCookie(now);
    navigateForStaleAppAssets(now);
}

/** One reload per cooldown — used by ErrorFallback, service worker, and global handlers. */
export function reloadForStaleAppAssets() {
    const now = Date.now();
    if (shouldSkipStaleAssetReload(now)) return false;
    setReloadCooldownCookie(now);
    navigateForStaleAppAssets(now);
    return true;
}

/** Catch chunk failures that never reach the React error boundary (dynamic import rejections). */
export function installStaleAssetRecoveryHandlers() {
    if (typeof window === "undefined" || window.__staleAssetRecoveryInstalled) return;
    window.__staleAssetRecoveryInstalled = true;

    window.addEventListener("unhandledrejection", (event) => {
        if (!isStaleAssetChunkError(event?.reason)) return;
        event.preventDefault();
        reloadForStaleAppAssets();
    });

    window.addEventListener("error", (event) => {
        if (!isStaleAssetChunkError(event?.error || event?.message)) return;
        reloadForStaleAppAssets();
    });
}
